import { useCallback } from 'react';
import FilterWizardBody from 'components/Wizards/MetaFilters';
import FilterWizardFooter from 'components/Wizards/MetaFilters/Footer';
import { AREA_RESPONSES } from 'components/Wizards/Dashlet/types';
import ClearFilters from '../ClearFilters';

import { useWizardFilterContext } from 'components/Wizards/MetaFilters/context';

export const DynamicObjectMetaFilter = ({
  onClear,
  filtersAreEmpty,
  onFilterConfirm,
  additionalFields,
  hideWarnings,
  hideGroups,
  hideLLMDecision,
  area,
  selectedObject,
  defaultCustomFilter,
  intitialRenderRef,
  showDescription,
}) => {
  const {
    filterOps: { reset },
    valid,
  } = useWizardFilterContext();

  const handleClear = useCallback(
    (...props) => {
      onClear(...props);
      reset();
    },
    [onClear, reset]
  );

  return (
    <>
      <FilterWizardBody
        hideWarnings={hideWarnings}
        additionalFields={additionalFields}
        disabled={area === AREA_RESPONSES.ACTIVITIES ? !selectedObject : false}
        footer={
          onClear && reset && !filtersAreEmpty ? (
            <ClearFilters onClear={handleClear} />
          ) : null
        }
        hideGroups={hideGroups}
        hideLLMDecision={hideLLMDecision}
        area={area}
        defaultCustomFilter={defaultCustomFilter}
        intitialRenderRef={intitialRenderRef}
        showDescription={showDescription}
      />
      <FilterWizardFooter
        valid={valid || filtersAreEmpty}
        onConfirm={onFilterConfirm}
      />
    </>
  );
};
